<template>
  <v-data-table
    show-select
    v-model="localValue"
    :headers="headers"
    :items="fornecedores.content"
    class="elevation-1 mt-2"
    :loading="loading"
    :server-items-length="fornecedores.total"
    @update:options="updateOptions"
    @item-selected="onSelectItem"
    :footer-props="footerOptions"
    no-data-text="Nenhum fornecedor encontrado"
    loading-text="Carregando fornecedores..."
    :options="optionsList"
  >
    <template v-slot:item.pessoa.nome="{ item }">
      <px-span-tooltip
        top
        :text="codigoInterno(item)"
        tooltip="Código interno do fornecedor"/>
        {{ item.pessoa.nome }}
      <px-popover-fornecedor :fornecedor-id="item.id"
                             :show-score="false"/>
    </template>
    <template v-slot:item.cnpj="{ item }">
      <px-fornecedor-documento :fornecedor="item"/>
    </template>
    <template v-slot:item.local="{ item }">
      {{ endereco(item) }}
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: {
    value: Array,
    fornecedores: Object,
    loading: Boolean,
    optionsList: Object,
    onChangeOptions: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Nome',
          value: 'pessoa.nome',
          sortable: true,
        },
        {
          text: 'Documento',
          value: 'cnpj',
          sortable: true,
        },
        {
          text: 'Local',
          value: 'local',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    codigoInterno() {
      return item => (item.codigoInterno ? `${item.codigoInterno} -` : '');
    },
    endereco() {
      return (item) => {
        const { municipio, estado } = item.endereco;
        if (municipio?.id && estado?.id) {
          return `${municipio.nome} (${estado.sigla})`;
        }
        const { cidade, pais } = item.endereco;
        if (cidade && pais?.id) {
          return `${cidade}, ${pais.nome}(${pais.sigla})`;
        }
        return '-';
      };
    },
  },
  methods: {
    onSelectItem() {
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
  },
};
</script>
